var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.666667 597.333333v-131.84c-30.72-14.08-59.306667-31.146667-85.333334-51.2V597.333333h85.333334m-85.333334 170.666667H128v-85.333333H42.666667v-85.333334h85.333333V298.666667h85.333333v61.013333C290.133333 426.666667 395.52 469.333333 512 469.333333c116.48 0 221.866667-42.666667 298.666667-109.653333V298.666667h85.333333v298.666666h85.333333v85.333334h-85.333333v85.333333h-85.333333v-85.333333H213.333333v85.333333m512-302.506667V597.333333h85.333334V414.293333c-26.026667 20.053333-54.613333 37.12-85.333334 51.2M682.666667 597.333333v-114.346666c-27.306667 9.813333-55.893333 17.066667-85.333334 22.186666V597.333333h85.333334m-128 0v-87.04L512 512l-42.666667-1.706667V597.333333h85.333334m-128 0v-92.16c-29.44-5.12-58.026667-12.373333-85.333334-22.186666V597.333333h85.333334z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.f1c02d4a8ba3c8c9f62b6cc6f36aed4a.svg";
export { ForwardRef as ReactComponent };